/**
 * Runtime trace helper for upp-konva debugging.
 * `globalThis.__UPP_KONVA_TRACE__ = true` — the Konva demo sets it if URL or localStorage enables debug.
 *
 * Uses `console.log` (not `debug`) so it shows with default DevTools levels.
 */
export function uppKonvaRuntimeTrace(tag: string, detail?: unknown): void {
  if ((globalThis as { __UPP_KONVA_TRACE__?: boolean }).__UPP_KONVA_TRACE__ !== true) {
    return;
  }
  const stamp =
    typeof performance !== 'undefined' && typeof performance.now === 'function'
      ? ` +${performance.now().toFixed(1)}ms`
      : '';
  console.log(`[upp-konva${stamp}]`, tag, detail !== undefined ? detail : '');
}
